import FetchStatusRepository from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import CurrentPage           from "../../../../domain/fundamentals/pagination/CurrentPage";
import MailGroupId           from "../../../../domain/mail/group/MailGroupId";
import MailGroupRepository   from "../../../../domain/mail/group/MailGroupRepository";
import FetchStatusDataSource from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import MailGroupDataSource   from "../../../../infrastructure/datasource/mail/group/MailGroupDataSource";
import NotifyDataSource      from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import GetMailGroups         from "./GetMailGroups";

class DeleteMailGroup {
  private readonly mailGroupRepository: MailGroupRepository = new MailGroupDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);
  private readonly getMailGroups: GetMailGroups = new GetMailGroups(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(mailGroupId: MailGroupId) {
    this.fetchStatusRepository.start();
    try {
      await this.mailGroupRepository.delete(mailGroupId);
      await this.getMailGroups.execute(new CurrentPage());
      this.notifyRepository.deleteSuccess();
    } catch (e) {
      this.notifyRepository.deleteFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default DeleteMailGroup;
